import Icon3Titles from '@/frontend/components/qecomps/Icon3Titles';
import TextBoxBottom from '@/frontend/components/qecomps/TextBoxBottom';
import { useEffect, useState } from 'react';
// import LoginFloat from '../Menu/LoginFloat';
import Comment from './Comment'
import LinkHashtags from '@/frontend/components/qecomps/LinkHashtags';

import SerialGenerator from '@/frontend/components/qecomps/SerialGenerator';
const CommentManage = dynamic(() => import('./CommentManage.tsx').then(x => x.default), { ssr: false })
const CommentsAdmin = dynamic(() => import('./CommentsAdmin.tsx').then(x => x.default), { ssr: false })

import Component, { PageEl } from '@/frontend/components/qecomps/Component'
import dynamic from 'next/dynamic';
import Img from '../qecomps/Img.tsx';
export default p => Component(p, Page);
const Page: PageEl = (props: {} & { [key: string]: any }, refresh, getProps, onLoad, onConnected, dies, isFront, z) => {

  // let [mention, setMention] = useState<any>({ test: 1 })

  if (!props.mention) {
    props.mention = { test: 1 }
  }
  props.restate(refresh);

  let isAdmin = z.user.role.includes("admin") || z.user.role.includes("explore")

  for (let cmnt of props.item.comments) {
    if (!cmnt.view) {
      cmnt.view = <Comment
        id={props.id}
        idkey={props.idkey}
        key={"cmnt_" + cmnt.cmntid}
        item={props.item}
        comment={cmnt}
        control={cmnt}
        mentions={[]}
        mentioningstep={10}
        loginrequired={() => { global.login() }}
        onrefresh={() => { }}
        onlike={cm => { refresh({ form: "manage", cmnt: cm, cmntid: cm.cmntid, cmntuid: cm.uid }) }}
        ondislike={cm => { refresh({ form: "manage", cmnt: cm, cmntid: cm.cmntid, cmntuid: cm.uid }) }}
        onmention={(obj) => { removementions(); props.mention = obj; }}
        onavatarclick={cm => { refresh({ form: "manage", cmnt: cm, cmntid: cm.cmntid, cmntuid: cm.uid }) }}
        zerodate={cmnt.date == 0}
      />
    }
  }

  let region = z.lang.region || "en-US"
  var alt = false, shift = false, ctrl = false;

  const sendComment = async (zerodate: boolean = false) => {
    if (z.user?.limited) {
      alerter(z.lang.limiterr.replace("XX", new Date(z.user.limited as number).toLocaleString(region).replace(" ", " ")));
      return
    }

    let tempid = SerialGenerator(5)

    if (props.mention.uid) {
      props.item.comments.forEach(cm => {
        if (cm.mention?.parentid == props.mention.parentid) {
          cm.show = true;
        }
      })
    }

    let pr = null

    if (props.mention.uid) {
      pr = props.item.comments.find(c => c.cmntid == props.mention.parentid)
    }

    let obj: any = {
      date: new Date().getTime(),
      tempid: tempid,
      cmntid: SerialGenerator(5),
      uid: props.commenteruser.uid,
      name: props.commenteruser.name,
      comment: props.commenttext,
      image: props.commenteruser.image,
      imageprop: props.commenteruser.imageprop,
      likes: 0,
      dislikes: 0,
      verify: props.commenteruser.verify,
      sending: false,
      mention: props.mention.uid ? props.mention : null,
      show: true,
    }

    obj.view = <Comment
      key={"cmnt_" + obj.cmntid}
      id={props.id}
      idkey={props.idkey}
      item={props.item}
      comment={obj}
      parent={pr}
      control={obj}
      mentions={[]}
      mentioningstep={10}
      loginrequired={() => { global.login() }}
      onrefresh={() => { }}
      onlike={cm => { refresh({ form: "manage", cmnt: cm, cmntid: cm.cmntid, cmntuid: cm.uid }) }}
      ondislike={cm => { refresh({ form: "manage", cmnt: cm, cmntid: cm.cmntid, cmntuid: cm.uid }) }}
      onmention={(o) => { removementions(); props.mention = o; }}
      onavatarclick={cm => { refresh({ form: "manage", cmnt: cm, cmntid: cm.cmntid, cmntuid: cm.uid }) }}
    />

    if (props.mention.uid) {
      let parent = props.item.comments.find(cm => cm.cmntid == props.mention.parentid)
      let personIndex = 0
      if (props.mention.parentid != props.mention.cmntid) {
        parent.view.props.mentions.forEach((m, i) => {
          if (m.view.props.comment.cmntid == props.mention.cmntid) {
            personIndex = i + 1;
          }
        })
      }
      parent.view.props.mentions.splice(personIndex, 0, obj)
      parent.view.props.control.reload();
    }
    else {
      props.item.comments.unshift(obj)
    }

    if (props.mention.uid) {
      document.getElementById(props.id + "_mention").className = z.styles.mentionhide
      if (props.mention.parentid == props.mention.cmntid) {
        let cm = props.item.comments.find(c => c.cmntid == props.mention.cmntid)
        cm.mentioning = false;
        cm.view.props.comment.mentioning = false;
        cm.view.props.control.reload();
      }
      else {
        let p = props.item.comments.find(c => c.cmntid == props.mention.parentid)
        let cm = p.view.props.mentions.find(c => c.cmntid == props.mention.cmntid)
        cm.mentioning = false;
        cm.view.props.comment.mentioning = false;
        cm.view.props.control.reload();
      }
    }
    // setComments([...comments]);
    refresh()

    let json = await API['comment/comments']({
      type: "write",
      // jid: props.item.jid?.toString(),
      id: props.id,
      idkey: props.idkey,
      email: props.commenteruser.email,
      uid: props.commenteruser.uid.toString(),
      verify: props.commenteruser.verify,
      comment: props.commenttext,
      mention: props.mention.uid ? props.mention : null,
      zerodate,
      tempid
    })

    setTimeout(() => {
      removementions();
      props.mention = {}
    }, 500)


    if (json.code == 0) {
      props.item.commentscount++;
      if (json.parentid) {
        let p = props.item.comments.find(cm => cm.cmntid == json.parentid)
        if (p) {
          let m = p.view.props.mentions.find(cm => cm.tempid == json.tempid)
          if (m) {
            m.sending = false
            m.cmntid = json.cmntid
            m.reload()
          }
        }
      }
      else {
        let cm = props.item.comments.find(cmnt => cmnt.tempid == json.tempid)
        if (cm) {
          cm.sending = false
          cm.cmntid = json.cmntid
          cm.reload()
        }
      }
      refresh({ form: null })
    }
    else if (json.code == -5) {
      alerter(z.lang.limiterr.replace("XX", new Date(json.date).toLocaleString(region).replace(" ", " ")));
    }
    else {
      alerter(z.lang.somethingwrong + " " + json.code);
    }
  }

  const removementions = () => {
    let cm = props.item.comments.find(c => c.view?.props.comment.mentioning)
    if (cm) {

      cm.mentioning = false;
      cm.view.props.comment.mentioning = false;
      cm.view.props.control.reload();
      refresh()
    }
    props.item.comments.forEach(c => c.view?.props.mentions.forEach(m => {
      if (m.view.props.comment.mentioning) {
        m.mentioning = false;
        m.view.props.comment.mentioning = false;
        m.view.props.control.reload();
      }
    }))
  }

  useEffect(() => {
    global.setScroller("comment_" + props.id)
  })

  // comments = comments.filter((_, i) => i < count || _.mention?.uid);

  const preSend = async (text) => {
    props.commenttext = text
    props.commenteruser = {
      name: z.user.name, uid: z.user.uid, image: z.user.image,
      imageprop: z.user.imageprop,
      verify: (z.user.role.includes("admin") || z.user.role.includes("comment") || z.user.role.includes("commenter")) ? "admin" :
        (z.user.uid == props.item.uid ? "owner" : null)
    }
    if (isAdmin) {
      props.form = "sendspecs"
      refresh()
    }
    else {
      await sendComment(false)
    }
  }



  return <>


    {props.form == "manage" &&
      (z.user.role.includes("admin") || z.user.role.includes("commenter"))
      ? <CommentManage
        idkey={props.idkey}
        id={props.id}
        cmntid={props.cmntid}
        cmnt={props.cmnt}
        item={props.item}
        itsme={async () => {
          let json = await API['comment/comments']({
            type: "itsme",
            idkey: props.idkey,
            id: props.id,
            cmntid: props.cmntid,
          })
          if (json.code == 0) {
            props.cmnt.uid = z.user.uid
            props.cmnt.image = z.user.image
            props.cmnt.imageprop = z.user.imageprop
            props.cmnt.name = z.user.name
            props.cmnt.verify = "admin"
            props.cmnt.reload()
          }
        }}

        randomuser={async () => {

          let { view, ...others } = props.cmnt
          let parentcmnt = props.item.comments.find(cm => cm.cmntid == others.mention?.cmntid)

          let jsonuser = await API['comment/commenter']({
            type: "changeuser",
            context: props.cmnt.context || parentcmnt?.context || (Math.random() > 0.5) ? "iranian" : "forex"
          })

          if (jsonuser.code == 0) {
            let json = await API['comment/comments']({
              type: "changeuser",
              idkey: props.idkey,
              id: props.id,
              cmntid: props.cmntid,
              newuid: jsonuser.user.uid
            })
            if (json.code == 0) {
              props.cmnt.uid = jsonuser.user.uid
              props.cmnt.image = jsonuser.user.image
              props.cmnt.imageprop = jsonuser.user.imageprop
              props.cmnt.name = jsonuser.user.name
              props.cmnt.verify = ""
              props.cmnt.reload()
            }
          }
        }}

        itsparent={async () => {
          let { view, ...others } = props.cmnt

          if (others.mention?.cmntid) {
            let parentcmnt = props.item.comments.find(cm => cm.cmntid == (others.mention?.parentid || others.parentid))

            if (parentcmnt) {
              let json = await API['comment/comments']({
                type: "changeuser",
                idkey: props.idkey,
                id: props.id,
                cmntid: props.cmntid,
                newuid: parentcmnt.uid
              })
              if (json.code == 0) {
                props.cmnt.uid = parentcmnt.uid
                props.cmnt.image = parentcmnt.image
                props.cmnt.imageprop = parentcmnt.imageprop
                props.cmnt.name = parentcmnt.name
                props.cmnt.verify = parentcmnt.verify
                props.cmnt.reload()
              }
            }
          }
          refresh({ form: null })

        }}
        sendreply={async (reply) => {

          props.mention = {
            cmntid: props.cmntid,
            uid: props.cmntuid,
            parentid: props.cmntid
          }

          props.commenttext = reply
          props.commenteruser = {
            name: z.user.name, uid: z.user.uid, image: z.user.image,
            imageprop: z.user.imageprop, verify: "admin"
          }
          await sendComment()
        }}
        onclose={() => { refresh({ form: null }) }} /> : null}


    {props.form == "sendspecs" &&
      (z.user.role.includes("admin") || z.user.role.includes("commenter") || z.user.role.includes("comment")) ?
      <CommentsAdmin
        idkey={props.idkey}
        id={props.id}
        item={props.item}
        mention={props.mention}
        parent={props}
        onclose={() => refresh({ form: null })}
        sendComment={sendComment}
      /> : null}


    <div className={props.show ? (z.styles.cmntparent + " " + z.styles.bg1) : z.styles.none}>
      <div style={{ position: "relative", width: "100%", height: "100%" }}>

        <Icon3Titles title1={props.title1}
          title2={props.title2}
          title3={props.title3}
          icon={props.icon} on={() => {
            // props.onback?.();
            props?.onclose?.()
            refresh({ show: false })
            global.setScroller("wind");
            global.cmntfinished = null
            global.cmntfetching = null;
            global.cmntloading = null;
            // setComments(comments.splice(0, 60))
          }} />

        <div id={"comment_" + props.id} style={{ height: "calc(100% - 100px)", overflowY: "auto" }} onScroll={async (e) => {

          if ((e.currentTarget.scrollHeight - e.currentTarget.clientHeight) - e.currentTarget.scrollTop < 500 &&
            !global.cmntfetching && !global.cmntfinished) {
            global.cmntfetching = true;
            setTimeout(() => {
              global.cmntfetching = false;
            }, 3000);

            let json = await API['comment/comments']({
              type: "get",
              lang: z.lang.code,
              idkey: props.idkey,
              id: props.id,
              skip: props.item.comments.length,
              limit: 50
            })

            if (json.code == 0) {
              if (json.comments.length == 0) {
                global.cmntfinished = true;
              }
              else {
                global.cmntfetching = false
                let tcm = []
                json.comments.forEach(c => {
                  if (!props.item.comments.find(cm => cm.cmntid == c.cmntid)) {
                    tcm.push({
                      ...c,
                      view: <Comment
                        key={"cmnt_" + c.cmntid}
                        id={props.id}
                        idkey={props.idkey}
                        item={props.item}
                        comment={c}
                        control={c}
                        mentions={[]}
                        mentioningstep={10}
                        onlike={cm => { refresh({ form: "manage", cmnt: cm, cmntid: cm.cmntid, cmntuid: cm.uid }) }}
                        ondislike={cm => { refresh({ form: "manage", cmnt: cm, cmntid: cm.cmntid, cmntuid: cm.uid }) }}
                        loginrequired={() => { global.login() }}
                        onrefresh={() => { }}
                        onmention={(obj) => { removementions(); props.mention = obj; }}
                        onavatarclick={cm => { refresh({ form: "manage", cmnt: cm, cmntid: cm.cmntid, cmntuid: cm.uid }) }}
                      />
                    })
                  }
                })
                props.item.comments.push(...tcm)
                refresh()
                // setComments([...comments])
              }
            }
          }
        }}>
          <p className={z.styles.text} style={{ padding: "5px 12px 0 12px" }}>{
            LinkHashtags(props.item.explaination || props.item.comment)}
          </p>
          <br-x />


          {props.item.comments.map(c => c.view)}


          {!props.iswide ? <><br-x /><br-x /><br-x /><br-x /></> : null}
          {props.iswide ? <><br-x /><br-x /></> : null}
        </div>

        {props.iswide && props.isopen ? null : <><br /><br /></>}


        {props.item.show && props.iswide ? <div style={{
          position: "absolute", top: 18,
          zIndex: 300, right: z.lang.dir == "rtl" ? null : 20, left: z.lang.dir == "rtl" ? 20 : null,
          cursor: "pointer"
        }} onClick={() => {
          // props.onback?.()
          refresh({ show: false })
          global.setScroller("wind")
          global.cmntfinished = null
          global.cmntfetching = null;
          global.cmntloading = null;
          // refresh({ comments: props.item.comments.splice(0, 60) })
          // setComments(comments.splice(0, 60));
        }} ><Img src={global.cdn("/files/close.svg")} style={{ width: 25, height: 25, marginTop: 10 }} /></div> : null}



        {props.iswide && props.show ? <f-cc className={z.styles.bg1} style={{
          position: "absolute", bottom: 3, height: 37, zIndex: 220, flex: 1, left: 0,
          width: "40rem", borderRadius: 3
        }}>

          <div style={{ paddingLeft: 8, paddingTop: 4, paddingBottom: 1, paddingRight: 10, cursor: "pointer", }} onClick={() => {
            // props.onback?.(); 
            refresh({ show: false })
            global.cmntfinished = null
            global.cmntfetching = null;
            global.cmntloading = null;
            global.setScroller("wind");
          }}>
          </div>
          <textarea id={props.id + "_cmnttxt"} className={z.styles.txtsidecmt + " " + z.styles.textboxbg}
            style={{ fontFamily: "vr", direction: z.lang.dir as any, marginBottom: 10, paddingRight: 10, paddingLeft: 10 }}
            placeholder={z.lang.writeyourcomment} dir="auto"
            onClick={() => {
              if (!z.user.loggedin) {
                global.login()
              }
            }}
            onKeyDown={async (e) => {
              if (!z.user.loggedin) {
                global.login()
                return
              }


              if ((e.code == "Enter" || e.code == "NumpadEnter" || e.key == "Enter") && !e.altKey && !e.ctrlKey && !e.shiftKey && e.currentTarget.value.trim().length > 0) {
                e.preventDefault();
                let txt_ = e.currentTarget.value
                e.target.value = ""
                e.currentTarget.value = "";
                await preSend(txt_)
              }
            }}
            onKeyUp={(e) => {
              if (!z.user.loggedin) {
                global.login()
                return
              }
            }}
          />
          <div style={{ paddingLeft: 8, paddingTop: 5, paddingBottom: 3, paddingRight: 10, cursor: "pointer", }}
            onClick={async (e) => {
              if (!z.user.loggedin) {
                global.login()
                return
              }
              var el = document.getElementById(props.id + "_cmnttxt") as HTMLTextAreaElement

              if (el.value.trim().length > 0) {
                await preSend(el.value)
                el.value = "";
                e.preventDefault();
              }
            }}>

            <icon class='w-[30px] h-[30px] icon-[lets-icons--send-hor-light]' style={{ marginTop: 0, transform: z.lang.dir == "rtl" ? "rotate(180deg)" : null }} />
          </div>

        </f-cc> : null}


        {props.iswide && props.show ? <f-csb id={props.id + "_mention"} class={z.styles.mentionhide} >

          <span style={{ direction: "ltr" }} id={props.id + "_mention_name"}></span>
          <Img src={global.cdn("/files/close.svg")} style={{ width: 20, height: 20, cursor: "pointer" }} on={() => {
            removementions();
            document.getElementById(props.id + "_mention").className = z.styles.mentionhide
            props.mention = {}
          }} /></f-csb> : null}

      </div>

    </div>


    {props.iswide && props.show ? <div className={z.styles.blackblurybg} style={{ zIndex: 20 }} onClick={() => {
      // props.onback?.();
      props.onclose?.()
      refresh({ show: false })
      global.cmntfinished = null
      global.cmntfetching = null;
      global.cmntloading = null;
      global.setScroller("wind")
    }}></div> : null}

    {props.show && !props.iswide ? <div style={{
      position: "fixed", top: "1.3rem", zIndex: 300,
      right: z.lang.dir == "ltr" ? 20 : null, left: z.lang.dir == "rtl" ? 20 : null, cursor: "pointer"
    }}
      onClick={() => {
        props?.onclose?.()
        refresh({ show: false })
        global.cmntfinished = null
        global.cmntfetching = null;
        global.cmntloading = null;

        global.setScroller("wind")
      }} ><Img src={global.cdn("/files/close.svg")} style={{ width: 25, height: 25 }} /></div> : null}




    {(!props.iswide && props.show) ? <TextBoxBottom
      id={props.id}
      placeholder={z.lang.writeyourcomment}
      loginrequired={() => global.login()}
      onmentionclose={() => {
        removementions();
        props.mention = {}
      }}

      on={async obj => {
        await preSend(obj.text)
      }}
    /> : null}

  </>
}
